// Author YuJiaBei
// Date 2020-08-07 16:27:20

class EmArchCostStatistic {
constructor({
        id = null,
        emArchBasicDataCode = '',
        emActProcessDefinitionRegisterCode = '',
        businessKey = '',
        emArchCostStatisticTypeId = '',
        resourceCode = '',
        resourceId = '',
        resourceName = '',
        price = '',
        count = '',
        totalCost = '',
        remark = ''}
= {}) {
    this.id = id;
    this.emArchBasicDataCode = emArchBasicDataCode;
    this.emActProcessDefinitionRegisterCode = emActProcessDefinitionRegisterCode;
    this.businessKey = businessKey;
    this.emArchCostStatisticTypeId = emArchCostStatisticTypeId;
    this.resourceCode = resourceCode;
    this.resourceId = resourceId;
    this.resourceName = resourceName;
    this.price = price;
    this.count = count;
    this.totalCost = totalCost;
    this.remark = remark;
}
}

function newEntity() {
return new EmArchCostStatistic();
}

function gridFields() {
return Object.freeze([
        {
        key: 'emArchBasicDataName',
        label: 'label.em.archive.emArchCostStatistic.grid.emArchBasicDataName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emActProcessDefinitionRegisterName',
        label: 'label.em.archive.emArchCostStatistic.grid.emActProcessDefinitionRegisterName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'businessKey',
        label: 'label.em.archive.emArchCostStatistic.grid.businessKey',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchCostStatisticTypeName',
        label: 'label.em.archive.emArchCostStatistic.grid.emArchCostStatisticTypeName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'resourceId',
        label: 'label.em.archive.emArchCostStatistic.grid.resourceId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'resourceName',
        label: 'label.em.archive.emArchCostStatistic.grid.resourceName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'price',
        label: 'label.em.archive.emArchCostStatistic.grid.price',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'count',
        label: 'label.em.archive.emArchCostStatistic.grid.count',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'totalCost',
        label: 'label.em.archive.emArchCostStatistic.grid.totalCost',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchCostStatistic.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    emArchBasicDataCodeFilter : "",
    emActProcessDefinitionRegisterCodeFilter : "",
    businessKeyFilter : "",
    emArchCostStatisticTypeIdFilter : "",
    resourceCodeFilter : "",
    resourceIdFilter : "",
    resourceNameFilter : "",
    priceGeFilter : "",
    priceLeFilter : "",
    countGeFilter : "",
    countLeFilter : "",
    totalCostGeFilter : "",
    totalCostLeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'emArchBasicDataCodeFilter',
        label: 'label.em.archive.emArchCostStatistic.filter.emArchBasicDataCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'emActProcessDefinitionRegisterCodeFilter',
        label: 'label.em.archive.emArchCostStatistic.filter.emActProcessDefinitionRegisterCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emActProcessDefinitionRegister'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'businessKeyFilter',
        label: 'label.em.archive.emArchCostStatistic.filter.businessKey',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emArchCostStatisticTypeIdFilter',
        label: 'label.em.archive.emArchCostStatistic.filter.emArchCostStatisticTypeId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchCostStatisticType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'resourceCodeFilter',
        label: 'label.em.archive.emArchCostStatistic.filter.resourceCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'resourceIdFilter',
        label: 'label.em.archive.emArchCostStatistic.filter.resourceId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'resourceNameFilter',
        label: 'label.em.archive.emArchCostStatistic.filter.resourceName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'priceGeFilter',
        label: 'label.em.archive.emArchCostStatistic.filter.priceGe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'priceLeFilter',
        label: 'label.em.archive.emArchCostStatistic.filter.priceLe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'countGeFilter',
        label: 'label.em.archive.emArchCostStatistic.filter.countGe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'countLeFilter',
        label: 'label.em.archive.emArchCostStatistic.filter.countLe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'totalCostGeFilter',
        label: 'label.em.archive.emArchCostStatistic.filter.totalCostGe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'totalCostLeFilter',
        label: 'label.em.archive.emArchCostStatistic.filter.totalCostLe',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'emArchBasicDataCode',
        label: 'label.em.archive.emArchCostStatistic.entity.emArchBasicDataCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'emActProcessDefinitionRegisterCode',
        label: 'label.em.archive.emArchCostStatistic.entity.emActProcessDefinitionRegisterCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emActProcessDefinitionRegister'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'businessKey',
        label: 'label.em.archive.emArchCostStatistic.entity.businessKey',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emArchCostStatisticTypeId',
        label: 'label.em.archive.emArchCostStatistic.entity.emArchCostStatisticTypeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emArchCostStatisticType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'resourceCode',
        label: 'label.em.archive.emArchCostStatistic.entity.resourceCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
            ,type: 'variable'
            ,dependentStateKey: 'emArchCostStatisticTypeId'
            ,dependentStateByModuleRoot: false
            ,forms: {
                2293: {
                key: 'resourceCode',
                label: 'label.em.archive.emArchCostStatistic.entity.resourceCode.2293',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emArchLaborCostStand'
                    ,correspondingField: 'id'
                    ,fieldsBindingByEntityModalSelected: '{"resourceName":"typeOfWork","price":"hourly"}'
                }
                },
                2292: {
                key: 'resourceCode',
                label: 'label.em.archive.emArchCostStatistic.entity.resourceCode.2292',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'sparePart'
                    ,correspondingField: 'code'
                    ,fieldsBindingByEntityModalSelected: '{"resourceName":"name"}'
                }
                }
            }
        },
        {
        key: 'resourceId',
        label: 'label.em.archive.emArchCostStatistic.entity.resourceId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
            ,type: 'variable'
            ,dependentStateKey: 'emArchCostStatisticTypeId'
            ,dependentStateByModuleRoot: false
            ,forms: {
                2293: {
                key: 'resourceId',
                label: 'label.em.archive.emArchCostStatistic.entity.resourceId.2293',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'employeeId'
                }
                },
                2292: {
                key: 'resourceId',
                label: 'label.em.archive.emArchCostStatistic.entity.resourceId.2292',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                }
                }
            }
        },
        {
        key: 'resourceName',
        label: 'label.em.archive.emArchCostStatistic.entity.resourceName',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'price',
        label: 'label.em.archive.emArchCostStatistic.entity.price',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'count',
        label: 'label.em.archive.emArchCostStatistic.entity.count',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'totalCost',
        label: 'label.em.archive.emArchCostStatistic.entity.totalCost',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchCostStatistic.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmArchCostStatistic, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
